import { SoilPhChart } from '@/components/charts/soil-ph-chart.component';
import { Loading } from '@/components/loading';
import { FieldNutrientInfoTable } from '@/components/tables/field-nutrient-info-table.component';
import { Body3, H3 } from '@/components/typography';
import { cn } from '@/lib/utils';
import { useFieldNutrientData, useSoilPhData } from '@/modules/Report/Report.api';

type FieldNutrientSectionProps = {
  farmId: string;
  fieldId: string;
};

export const FieldNutrientSection = ({ farmId, fieldId }: FieldNutrientSectionProps) => {
  const { data: fieldNutrients, status: nutrientStatus } = useFieldNutrientData(farmId, fieldId);
  const { data: phData, status: phStatus } = useSoilPhData(fieldId);

  if (nutrientStatus === 'pending' || phStatus === 'pending') {
    return <Loading />;
  }

  const hasNutrientData = fieldNutrients && fieldNutrients.some((nutrient) => nutrient.result?.value != null);
  const hasPhData = phData && phData.soilPh && Number(phData.soilPh) !== 0;

  if (!hasNutrientData && !hasPhData) {
    return null;
  }

  return (
    <>
      <H3>Field Nutrient Information</H3>
      <div className={cn('shadow p-7 mb-6')}>
        <SoilPhChart fieldId={fieldId} />
      </div>
      <div className={cn('flex gap-4')}>
        <div className={cn('flex items-center gap-2')}>
          <div className={cn('w-5 h-5 rounded-full bg-red')} />
          <Body3>Investigate</Body3>
        </div>
        <div className={cn('flex items-center gap-2')}>
          <div className={cn('w-5 h-5 rounded-full bg-yellow')} />
          <Body3>Review</Body3>
        </div>
        <div className={cn('flex items-center gap-2')}>
          <div className={cn('w-5 h-5 rounded-full bg-green')} />
          <Body3>Continue Rotational Monitoring</Body3>
        </div>
      </div>
      <FieldNutrientInfoTable farmId={farmId} fieldId={fieldId} />
    </>
  );
};
